import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';
import { getStateClasses, getOutlineClasses } from '../../utils/taillwind.js';

var _excluded = ["children", "compact", "outline", "state"];
var Badge = /*#__PURE__*/forwardRef(function Badge(props, ref) {
  var _cn;

  var children = props.children,
      _props$compact = props.compact,
      compact = _props$compact === void 0 ? false : _props$compact,
      _props$outline = props.outline,
      outline = _props$outline === void 0 ? false : _props$outline,
      state = props.state,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var className = cn('yt-badge', (_cn = {}, _cn[getStateClasses(state)] = !outline, _cn[getOutlineClasses(state)] = outline, _cn['yt-badge--compact'] = compact, _cn), props.className);
  return createElement("span", Object.assign({}, otherProps, {
    "aria-atomic": "true",
    "aria-live": "polite",
    className: className,
    ref: ref,
    role: "status",
    title: props['aria-label']
  }), compact ? createElement(VisuallyHidden, null, children) : children);
});

export { Badge };
//# sourceMappingURL=Badge.js.map
